import { selectFetchStatus } from "../../store/auth/selectors";
import { useDispatch, useSelector } from "../../store/store";
import { useLocation, useNavigate } from "react-router-dom";
import MotionWrapper from "../../containers/MotionWrapper";
import { validateEmail } from "../../utils/generalHelpers";
import { TypographyLogo } from "../../assets/icons/common";
import { signInThunk } from "../../store/auth/thunks";
import CheckBox from "../../components/CheckBox";
import Entrance from "../../layouts/Entrance";
import Button from "../../components/Button";
import Input from "../../components/Input";
import styles from './style.module.scss';
import { useState } from "react";

function SignInPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const from = location?.state?.from;
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const fetchStatus = useSelector(selectFetchStatus);

    const submit = () => {
        if (!validateEmail(email)) {
            setError('Email address is invalid.');
            return;
        }

        dispatch(signInThunk({
            username: email,
            password,
            from,
        }));
    };

    return (
        <Entrance>
            <MotionWrapper className={styles.wrapper}>
                <div className={styles.head}>
                    <TypographyLogo width={280} height={70} />
                    <span className={styles.head_devider} />
                    <span className={styles.head_title}>Sign in</span>
                </div>
                <span className={styles.description}>Please sign in to continue to your account.</span>
                <Input
                    focused
                    type="email"
                    value={email}
                    error={error}
                    label="Email"
                    onChange={setEmail}
                    wrapperClassName={styles.username}
                />
                <Input
                    value={password}
                    type="password"
                    label="Password"
                    onChange={setPassword}
                />
                <div className={styles.midd_row}>
                    <CheckBox
                        text="Remember Me"
                        checked={rememberMe}
                        setChecked={setRememberMe}
                    />
                    <span onClick={() => navigate('/forgetpassword')}>
                        Forgot your password?
                    </span>
                </div>
                <Button
                    text="Sign In"
                    onClick={submit}
                    loading={fetchStatus === 'Pending'}
                />
                <div className={styles.joinNow}>
                    <span>Don’t have an account? </span>
                    <span onClick={() => navigate('/signup', { state: { from } })}>
                        Sign up
                    </span>
                </div>
            </MotionWrapper>
        </Entrance>
    );
};

export default SignInPage;
